import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LocationContext } from "../context/LocationContext";

export default function CategoryLandingPage() {
  const navigate = useNavigate();
  const { address, loading, error } = useContext(LocationContext);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const categories = [
    {
      name: "Medicines",
      image: "/images/medicines.png",
      path: "/customer-dashboard",
    },
    {
      name: "Surgical Items",
      image: "/images/surgical.png",
      path: "/surgical-dashboard",
    },
  ];

  useEffect(() => {
    function handleOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  function handleLogout() {
    localStorage.clear();
    navigate("/login");
  }

  const menuItems = [
    { label: "Profile", action: () => navigate("/profile") },
    { label: "My Orders", action: () => navigate("/orders") },
    { label: "Logout", action: handleLogout, danger: true },
  ];

  const renderLocationText = () => {
    if (loading) return "Detecting location…";
    if (error) return "Location unavailable";
    if (address) return address;
    return "Location unavailable";
  };

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        {/* Left */}
        <div style={styles.left}>
          <div ref={menuRef} style={{ position: "relative" }}>
            <button
              style={styles.hamburger}
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen(!menuOpen);
              }}
            >
              <div style={styles.hamLine} />
              <div style={styles.hamLine} />
              <div style={styles.hamLine} />
            </button>

            {menuOpen && (
              <div style={styles.dropdown}>
                {menuItems.map((item) => (
                  <div
                    key={item.label}
                    style={{
                      ...styles.dropdownItem,
                      color: item.danger ? "#d93025" : "#111",
                    }}
                    onClick={() => {
                      setMenuOpen(false);
                      item.action();
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

  

        {/* Right */}
        <div style={styles.center}>
          <span style={styles.pin}>📍</span>
          <span style={styles.addressText}>{renderLocationText()}</span>
        </div>
      </div>

      {/* Banner */}
      <div style={styles.banner}>DELIVERY WITHIN 1 HOUR IN BAREILLY</div>

      {/* Categories */}
      <div style={styles.gridWrap}>
        <div style={styles.grid}>
          {categories.map((cat) => (
            <div
              key={cat.name}
              style={styles.catCard}
              onClick={() => navigate(cat.path)}
            >
              <img src={cat.image} alt={cat.name} style={styles.catImage} />
              <div style={styles.catName}>{cat.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ---------- Styles ---------- */
const styles = {
  page: { padding: 16, fontFamily: "system-ui" },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  left: { width: 50 },
  center: { flex: 1, textAlign: "center" },
  right: {
    maxWidth: 240,
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  title: { fontSize: 18, fontWeight: 700 },

  hamburger: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
  },
  hamLine: {
    width: 22,
    height: 3,
    background: "#222",
    margin: "4px 0",
    borderRadius: 2,
  },

  dropdown: {
    position: "absolute",
    top: 36,
    left: 0,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
    zIndex: 1000,
  },
  dropdownItem: {
    padding: "12px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  },

  pin: { fontSize: 14 },

  banner: {
    textAlign: "center",
    fontWeight: 800,
    margin: "16px 0",
    fontSize: 14,
  },

  gridWrap: { display: "flex", justifyContent: "center" },
  grid: {
    width: "100%",
    maxWidth: 900,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 20,
  },
  catCard: {
    background: "#fff",
    borderRadius: 12,
    padding: 20,
    textAlign: "center",
    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
    cursor: "pointer",
  },
  catImage: {
    width: 90,
    height: 90,
    objectFit: "contain",
    marginBottom: 10,
  },
  catName: { fontSize: 16, fontWeight: 700 },
};
